import { AdminBarberRepository } from "../../Repository";

export async function clickOnLogout(
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.signOut();
}
